<template>
  <div
    :class="{
      'activity-wrapper': true,
      'activity-wrapper-scroll': allowScroll,
      isDesktopAAActivity: isAAActivity && !isMobile
    }"
    :style="{
      padding: isMobile ? '25px 75px' : '25px 50px',
      ...customStyle
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'activity-wrapper',
  computed: {
    ...mapState('application', { isMobile: state => state.device.isMobile }),
    isAAActivity() {
      return this.isAssessmentAcceleratorActivity();
    }
  },
  methods: {
    ...mapGetters('activity', ['isAssessmentAcceleratorActivity'])
  },
  props: {
    allowScroll: {
      default: false,
      required: false,
      type: Boolean
    },
    customStyle: {
      default: () => ({}),
      required: false,
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/mixins';

.activity-wrapper {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.activity-wrapper-scroll {
  overflow: auto;
}

.isDesktopAAActivity {
  @include media(largest) {
    padding: 25px 50px !important;
  }

  padding: 25px 50px 70px 50px !important;
}
</style>
